var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormBuilderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.497,
    height: 18.005,
    viewBox: "0 0 19.497 18.005",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_22",
    "data-name": "Subtraction 22",
    d: "M14.841,18.5H12.705a.462.462,0,0,1-.462-.462V15.908a.456.456,0,0,1,.14-.321l4.27-4.271a1.983,1.983,0,0,1,2.778,0,1.992,1.992,0,0,1,0,2.778l-4.271,4.271A.458.458,0,0,1,14.841,18.5Zm3.2-6.859a1.054,1.054,0,0,0-.746.313l-4.13,4.13v1.492H14.66l4.13-4.13a1.059,1.059,0,0,0-.747-1.805ZM11.032,18.5H2.456A1.958,1.958,0,0,1,.5,16.549V2.456A1.958,1.958,0,0,1,2.456.5H16.549A1.958,1.958,0,0,1,18.5,2.456V9.608h-.923V5.693H1.424V16.549a1.033,1.033,0,0,0,1.032,1.032h8.576V18.5ZM2.456,1.424A1.033,1.033,0,0,0,1.424,2.456V4.77H17.581V2.456a1.033,1.033,0,0,0-1.032-1.032ZM11.032,16.37H3.347v-.923h7.685v.922Zm0-2.136H3.347v-.923h7.685v.922ZM13.879,12.1h-2.7v-.923h2.7V12.1ZM9.5,12.1H3.809a.462.462,0,0,1-.462-.462V7.367a.462.462,0,0,1,.462-.462H9.5a.462.462,0,0,1,.462.462v4.271A.462.462,0,0,1,9.5,12.1ZM4.27,7.829v3.347H9.041V7.829ZM15.658,9.965H11.176V9.041h4.482v.922Zm0-2.136H11.176V6.906h4.482v.922Zm0-4.27H9.041V2.635h6.617v.922Zm-7.829,0H6.194V2.635H7.829v.922Zm-2.847,0H3.347V2.635H4.982v.922Z",
    transform: "translate(-0.5 -0.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormBuilderIcon);
export default __webpack_public_path__ + "static/media/FormBuilderIcon.12857f04.svg";
export { ForwardRef as ReactComponent };